import { useLocalStorage } from 'usehooks-ts';

export default function useSelectedBankAccount(vehicleId: string | null) {
  return useLocalStorage<string | null>(
    `current-bank-account-id-${vehicleId}`,
    null,
  );
}
